import React, { createContext, useContext } from 'react';
import postsData from '../data/posts.json';

const PostsContext = createContext();

export const PostsProvider = ({ children }) => {
  return (
    <PostsContext.Provider value={{ postsData }}>
      <React.Fragment>
        {children}
      </React.Fragment>
    </PostsContext.Provider>
  );
};

export const usePosts = () => {
  const context = useContext(PostsContext);
  if (!context) {
    throw new Error('usePosts debe ser usado dentro de PostsProvider');
  }
  return context;
};
